import React from 'react'
import { useQuery } from 'react-query'

import { Grid } from '@material-ui/core'

import { Stats } from 'src/components/Stats'
import { skuit } from 'src/services/skuit'

export const HomePage = () => {
  const { data } = useQuery(['summary'], () => skuit.client.summary())
  return (
    <Grid container spacing={6}>
      <Grid item xs={6} sm={4} md={3}>
        <Stats
          title="Available Units"
          amount={data?.num_available ? data?.num_available.toLocaleString() : 0} //  eslint-disable-line camelcase
        />
      </Grid>
      <Grid item xs={6} sm={4} md={3}>
        <Stats
          title="Units Pending in Orders"
          amount={data?.num_reserved ? data?.num_reserved.toLocaleString() : 0} //  eslint-disable-line camelcase
        />
      </Grid>
      <Grid item xs={6} sm={4} md={3}>
        <Stats
          title="Total ASNs"
          amount={data?.num_asns ? data?.num_asns.toLocaleString() : 0} //  eslint-disable-line camelcase
        />
      </Grid>
      <Grid item xs={6} sm={4} md={3}>
        <Stats
          title="Total Orders"
          amount={data?.num_orders ? data?.num_orders.toLocaleString() : 0} //  eslint-disable-line camelcase
        />
      </Grid>
      <Grid item xs={6} sm={4} md={3}>
        <Stats
          title="Total Shipments"
          amount={data?.num_shipments ? data?.num_shipments.toLocaleString() : 0} //  eslint-disable-line camelcase
        />
      </Grid>
    </Grid>
  )
}
